import * as React from "react"
import { jnstyls } from '~/utils/helpers'

import Blocks from '~/templates/blog-blocks'

import { coll_blocks, solo_hero } from "~/styles/plp/plp.module.scss"

const CollBlocks = ({ blocks }) => {
  const only_full = blocks.length === 1 && blocks[0].type === 'story_full'
  const wrap_css = jnstyls([coll_blocks, only_full ? solo_hero : ''])

  blocks.forEach((block,index) => {
    if (!block.hasOwnProperty('id')) block.id = `pgblc${index}`
  })

  const pgprops = {pgblc: true}

  const post = {
    bg_color: '#fff',
    data: {published: '2023-10-22T08:02:24-07:00', blocks: blocks},
    excerpt: '',
    handle: '',
    id: 'collblocks',
    image: '',
    quick_color_oos: [],
    quick_obj: [],
    quick_pls: [],
    title: ''
  }
  
  return (
    <div className={wrap_css}>
      <Blocks post={post} pgprops={pgprops} />
    </div>
  )
}

export default CollBlocks





